var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 6 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.uploadOrderFile.open()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("upload")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("uploadOrderFile", { ref: "uploadOrderFile" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }